import { render, staticRenderFns } from "./employeeGroupTableExaminationAssignmentsDialog.vue?vue&type=template&id=13620e72"
import script from "./employeeGroupTableExaminationAssignmentsDialog.vue?vue&type=script&lang=js"
export * from "./employeeGroupTableExaminationAssignmentsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports